import { OrderDetail } from 'widgets/orderDetail';
import { Container } from './styles';
import { Guests } from 'features/hallmapToolbar/guests';
import { HallmapManager } from 'features/hallmapManager';
import { Booking } from 'widgets/booking';
import { OrderInfoProvider } from 'entities/orders';
import { useResize } from 'app/lib/hooks/useResize';

export const HallmapEventDashboard = () => {
  const { 
    isScreenSm
  } = useResize();

	return (
		<Container>
			<OrderInfoProvider>
				{isScreenSm && <HallmapManager />}
				<OrderDetail includePenButtonInPerson={true} />
				<Guests />
				{isScreenSm && <Booking resetPersonAfterClose={true} />}
			</OrderInfoProvider>
		</Container>
	);
};
